/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Content_Tools_HintInputs */

const cs_property_ai_content_tools_hint = /** @type {(inputs: Property_Ai_Content_Tools_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerujte nebo přeložte text inzerátu pro jazykovou záložku výše.`)
};

const en_property_ai_content_tools_hint = /** @type {(inputs: Property_Ai_Content_Tools_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate or translate listing copy for the language tab above.`)
};

/**
* | output |
* | --- |
* | "Generate or translate listing copy for the language tab above." |
*
* @param {Property_Ai_Content_Tools_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_content_tools_hint = /** @type {((inputs?: Property_Ai_Content_Tools_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Content_Tools_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_content_tools_hint(inputs)
	return cs_property_ai_content_tools_hint(inputs)
});